import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Component, Input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'nav-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [MatMenuModule],
})
export class NavMenuComponent {
  @Input() public text = '';
}
